
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { RolProps } from "../../interfaces/catalogos/RolInterface";

import { ActualizarRol, AgregarRol, Rol } from "../../connections/catalogos/RolConnection";
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

export const RolPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [RolArray, setRolArray] = useState<RolProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idRol, setIdRol] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( RolArray, ( item, filtro ) => item.descripcion.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const RolSelected = RolArray.find( ( elem ) => elem.idRol === id );

        if( RolSelected ){

            await ActualizarRol({ ...RolSelected, activo: checked }).then( resp => {
                
                if( resp.idRol ){

                    var newArray = RolArray.map( ( elem ) => {

                    if( elem.idRol === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setRolArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idRol !== 0 ){

            const RolSelected = RolArray.find( ( elem ) => elem.idRol === idRol );

            if( RolSelected ){

                setLoading( true );
    
                await ActualizarRol({ ...RolSelected, descripcion, }).then( resp => {
                    
                    if( resp.idRol ){

                        setTimeout(() => {
                            
                            var newArray = RolArray.map( ( elem ) => {
        
                                if( elem.idRol === idRol ){
                                    elem.descripcion = descripcion;
                                    elem.nombre = resp.nombre;
                                }
                        
                                return elem;
                            });
                    
                            setRolArray( newArray );
                            setOpenModal( false );
                            setLoading( false );
                           
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const RolesAdd: RolProps = {
                idRol: 0,
                nombre: "",
                descripcion,               
                activo: true,
            }

            setLoading( true );

            await AgregarRol( RolesAdd ).then( resp => {
                    
                if( resp.idRol ){                
            
                    setTimeout(() => {
                        
                        setRolArray([ ...RolArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el rol correctamente', variant: 'success' })); 

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setRolArray( [] );

            await Rol().then( resp => {

                setTimeout(() => {
                    
                    setRolArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Rol' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>
                    {
                        administrador
                        &&
                            <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }
                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>
                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdRol( 0 );
                            setDescripcion( '' );

                            setOpenModal( true );
                        }}
                    >
                        Agregar
                    </Button>
                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }} textAlign={'start'}>
                    <SearchTextField
                        value={ filtro }
                        label="Buscar rol"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    dataFiltrada
                            )
                            .map( ( { idRol, descripcion, activo } ) => (

                                <TableRow key={ idRol} >
                                
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idRol }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      
    
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idRol ) }
                                        />

                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdRol( idRol );
                                                    setDescripcion( descripcion );                                                   

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  
                                        
                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={1} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { dataFiltrada.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>
            
                <DialogContent sx={ DialogContentStyle }>
                       
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción'}
                        variant="outlined"                           
                        multiline
                        rows={4}                                        
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }} 
                    /> 

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => { setOpenModal( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}